import React from 'react';
import { NavLink, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import ProfileDetails from './ProfileDetails';
import OrderHistory from './OrderHistory';

function ProfileLayout({ t, hasUnseenOrders }) {
    const navigate = useNavigate();
    const menuItems = [
        { path: '/profile', label: t.profile || 'Profile', end: true },
        { path: '/profile/orders', label: t.order_history || 'Order History', end: false },
    ];

    return (
        <div className="container mx-auto mt-8">
            <div className="mb-6 flex justify-between items-center">
                <button
                    onClick={() => navigate('/')}
                    className="flex items-center text-indigo-600 hover:text-indigo-800 transition"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    {t.back_to_dashboard || 'Back to Dashboard'}
                </button>
            </div>
            <div className="flex gap-8">
                {/* Sidebar */}
                <aside className="w-64 flex-shrink-0">
                    <nav className="bg-white rounded-lg shadow overflow-hidden">
                        {menuItems.map((item) => (
                            <NavLink
                                key={item.path}
                                to={item.path}
                                end={item.end}
                                className={({ isActive }) =>
                                    `flex items-center gap-3 px-5 py-4 text-sm font-medium transition-colors border-l-4 ${isActive
                                        ? 'border-indigo-600 bg-indigo-50 text-indigo-700'
                                        : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                                    }`
                                }
                            >
                                {item.label === (t.profile || 'Profile') ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                    </svg>
                                ) : (
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                                    </svg>
                                )}
                                {item.label}
                                {item.path === '/profile/orders' && hasUnseenOrders && (
                                    <span className="ml-auto inline-flex items-center justify-center p-1 font-bold leading-none text-red-100 bg-red-600 rounded-lg text-xs select-none shadow-sm px-2">
                                        !
                                    </span>
                                )}
                            </NavLink>
                        ))}
                    </nav>
                </aside>

                {/* Main Content */}
                <main className="flex-1 min-w-0">
                    <Routes>
                        <Route index element={<ProfileDetails t={t} />} />
                        <Route path="orders" element={<OrderHistory t={t} />} />
                        <Route path="*" element={<Navigate to="" replace />} />
                    </Routes>
                </main>
            </div>
        </div>
    );
}

export default ProfileLayout;
